import React from 'react';
import PropTypes from 'prop-types';
import Loading from '../Loading';
import useAiModels from './useAiModels';
import AiTaskTable from './AiTaskTable';
import AiCatalogTable from './AiCatalogTable';
import AddAiModelForm from './AddAiModelForm';
import './settings.css';

// The AI models settings (CONTEXT.md "AI Models"): which model each AI
// task runs on, and the catalog those choices come from.
export default function AiModelsSection({ token }) {
    const { models, tasks, loading, busy, error, message, refresh, add, update, assign } = useAiModels({ token });

    if (loading) return <Loading />;

    return (
        <section className="st-section">
            <h3 className="st-title">AI models</h3>
            <p className="st-intro">
                Each AI task runs on one model. Only enabled models can be assigned; refresh the
                catalog to see what the providers offer, then enable the ones worth using.
            </p>
            {error && <p className="st-error" role="alert">{error}</p>}
            {message && <p className="st-message">{message}</p>}

            <h4 className="st-subtitle">Tasks</h4>
            <AiTaskTable tasks={tasks} models={models} busy={busy} onAssign={assign} />

            <div className="st-catalog-head">
                <h4 className="st-subtitle">Model catalog</h4>
                <button type="button" className="ne-btn" onClick={refresh} disabled={busy === 'refresh'}>
                    <i className={`pi ${busy === 'refresh' ? 'pi-spin pi-spinner' : 'pi-refresh'}`} /> Refresh from providers
                </button>
            </div>
            <AiCatalogTable models={models} busy={busy} onUpdate={update} />

            <h4 className="st-subtitle">Add a model by hand</h4>
            <AddAiModelForm busy={busy} onAdd={add} />
        </section>
    );
}

AiModelsSection.propTypes = {
    token: PropTypes.string.isRequired,
};
